import React from 'react';
import { Link } from 'react-router-dom';

const DepartmentsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center px-4 py-8">
      <header className="mb-6">
        <h1 className="text-3xl font-bold text-blue-700">Departments</h1>
      </header>
      <nav className="mb-6">
        <Link 
          to="/" 
          className="text-blue-500 underline hover:text-blue-600"
        >
          Back to Home
        </Link>
      </nav>
      <section className="w-full max-w-lg">
        <p className="text-gray-700 mb-4">Select a department to view its processes:</p>
        <ul className="space-y-4">
        <li>
            <Link 
              to="/procurement" 
              className="block p-4 bg-white shadow rounded hover:bg-blue-50 transition"
            >
              Procurement Department
            </Link>
          </li>
          <li>
            <Link 
              to="/finance" 
              className="block p-4 bg-white shadow rounded hover:bg-blue-50 transition"
            >
              Finance Department
            </Link>
          </li>
        

         
        </ul>
      </section>
    </div>
  );
};

export default DepartmentsPage;
